/**
 * @graph-stack styling-pattern-watch
 * @graph-domain Styling
 * @graph-business Styling Pattern Watch Web の必須 Vite 環境変数を起動時に検証する
 * @graph-connects none
 */
export function getApiBaseUrl(env: Pick<ImportMetaEnv, 'VITE_API_URL'> = import.meta.env): string {
  const apiUrl = env.VITE_API_URL?.trim();
  if (apiUrl === undefined || apiUrl === '') {
    throw new Error('VITE_API_URL is required');
  }
  return apiUrl;
}
